"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react"),
    t = require("@react-pdf-viewer/core");

function n(e) {
  if (e && e.__esModule) return e;
  var t = Object.create(null);
  return e && Object.keys(e).forEach(function (n) {
    if ("default" !== n) {
      var o = Object.getOwnPropertyDescriptor(e, n);
      Object.defineProperty(t, n, o.get ? o : {
        enumerable: !0,
        get: function get() {
          return e[n];
        }
      });
    }
  }), t.default = e, Object.freeze(t);
}

var o,
    r = n(e);
exports.SelectionMode = void 0, (o = exports.SelectionMode || (exports.SelectionMode = {})).Hand = "Hand", o.Text = "Text";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _c = function c() {
  return (_c = Object.assign || function (e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      for (var r in t = arguments[n]) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  }).apply(this, arguments);
},
    i = function i() {
  return r.createElement(t.Icon, {
    size: 16
  }, r.createElement("path", {
    d: "M11.5,5.5v-2C11.5,2.672,12.172,2,13,2s1.5,0.672,1.5,1.5v2 M14.5,11.5v-6C14.5,4.672,15.172,4,16,4\n            c0.828,0,1.5,0.672,1.5,1.5v3 M17.5,13V8.5C17.5,7.672,18.172,7,19,7s1.5,0.672,1.5,1.5v10c0,2.761-2.239,5-5,5h-3.335\n            c-1.712-0.001-3.305-0.876-4.223-2.321C6.22,18.467,4.083,14,4.083,14c-0.378-0.545-0.242-1.292,0.303-1.67\n            c0.446-0.309,1.044-0.281,1.458,0.07L8.5,15.5v-10C8.5,4.672,9.172,4,10,4s1.5,0.672,1.5,1.5v6"
  }));
},
    l = function l() {
  return r.createElement(t.Icon, {
    size: 16
  }, r.createElement("path", {
    d: "M13.675,11.671l2.941-2.941c0.195-0.196,0.195-0.512-0.001-0.707C16.563,7.971,16.5,7.931,16.43,7.906\n            L4.168,3.527C3.908,3.434,3.622,3.57,3.529,3.83c-0.039,0.109-0.039,0.228,0,0.336l4.379,12.262\n            c0.093,0.26,0.379,0.396,0.639,0.303c0.07-0.025,0.133-0.065,0.185-0.117l2.943-2.943l6.146,6.146c0.195,0.195,0.512,0.195,0.707,0\n            l1.293-1.293c0.195-0.195,0.195-0.512,0-0.707L13.675,11.671z"
  }));
},
    u = function u(e) {
  var n = e.children,
      o = e.mode,
      c = e.onClick,
      u = r.useContext(t.LocalizationContext),
      s = "",
      a = r.createElement(l, null);

  switch (o) {
    case exports.SelectionMode.Hand:
      s = u && u.selectionMode ? u.selectionMode.handTool : "Hand tool", a = r.createElement(i, null);
      break;

    case exports.SelectionMode.Text:
    default:
      s = u && u.selectionMode ? u.selectionMode.textSelectionTool : "Text selection tool", a = r.createElement(l, null);
  }

  return n({
    icon: a,
    label: s,
    onClick: c
  });
},
    s = {
  left: 0,
  top: 8
},
    a = function a(e) {
  var n = e.isSelected,
      o = e.mode,
      c = e.onClick;
  return r.createElement(u, {
    mode: o,
    onClick: c
  }, function (e) {
    return r.createElement(t.Tooltip, {
      ariaControlsSuffix: "selection-mode-switch",
      position: t.Position.BottomCenter,
      target: r.createElement(t.MinimalButton, {
        ariaLabel: e.label,
        isSelected: n,
        onClick: e.onClick
      }, e.icon),
      content: function content() {
        return e.label;
      },
      offset: s
    });
  });
},
    d = function d(e) {
  var t = e.children,
      n = e.mode,
      o = e.store,
      c = n === o.get("selectionMode");
  return (t || function (e) {
    return r.createElement(a, {
      isSelected: c,
      mode: e.mode,
      onClick: e.onClick
    });
  })({
    isSelected: c,
    mode: n,
    onClick: function onClick() {
      return o.update("selectionMode", n);
    }
  });
},
    m = function m(e) {
  var n = e.isSelected,
      o = e.mode,
      c = e.onClick;
  return r.createElement(u, {
    mode: o,
    onClick: c
  }, function (e) {
    return r.createElement(t.MenuItem, {
      checked: n,
      icon: e.icon,
      onClick: e.onClick
    }, e.label);
  });
},
    f = function f(e) {
  var t = e.store,
      n = r.useRef(null),
      o = r.useState(exports.SelectionMode.Text),
      c = o[0],
      i = o[1],
      l = r.useRef({
    top: 0,
    left: 0,
    x: 0,
    y: 0
  }),
      u = function u(e) {
    var t = n.current;
    t && (t.scrollTop = l.current.top - (e.clientY - l.current.y), t.scrollLeft = l.current.left - (e.clientX - l.current.x));
  },
      s = function s() {
    var e = n.current;
    e && (e.classList.add("rpv-selection-mode__grab"), e.classList.remove("rpv-selection-mode__grabbing"), document.removeEventListener("mousemove", u), document.removeEventListener("mouseup", s));
  },
      a = function a(e) {
    var t = n.current;
    t && c !== exports.SelectionMode.Text && (t.classList.remove("rpv-selection-mode__grab"), t.classList.add("rpv-selection-mode__grabbing"), e.preventDefault(), e.stopPropagation(), l.current = {
      left: t.scrollLeft,
      top: t.scrollTop,
      x: e.clientX,
      y: e.clientY
    }, document.addEventListener("mousemove", u), document.addEventListener("mouseup", s));
  },
      d = function d(e) {
    n.current = e();
  },
      m = function m(e) {
    i(e);
  };

  return r.useEffect(function () {
    var e = n.current;
    if (e) return c === exports.SelectionMode.Hand ? e.classList.add("rpv-selection-mode__grab") : e.classList.remove("rpv-selection-mode__grab"), e.addEventListener("mousedown", a), function () {
      e.removeEventListener("mousedown", a);
    };
  }, [c]), r.useEffect(function () {
    return t.subscribe("getPagesContainer", d), t.subscribe("selectionMode", m), function () {
      t.unsubscribe("getPagesContainer", d), t.unsubscribe("selectionMode", m);
    };
  }, []), r.createElement(r.Fragment, null);
};

exports.HandToolIcon = i, exports.TextSelectionIcon = l, exports.selectionModePlugin = function (e) {
  var n = r.useMemo(function () {
    return t.createStore();
  }, []),
      o = function o(e) {
    return r.createElement(d, _c({}, e, {
      store: n
    }));
  };

  return {
    install: function install(t) {
      n.update("selectionMode", e && e.selectionMode ? e.selectionMode : exports.SelectionMode.Text), n.update("getPagesContainer", t.getPagesContainer);
    },
    renderViewer: function renderViewer(e) {
      var t = e.slot;
      return t.subSlot && t.subSlot.children && (t.subSlot.children = r.createElement(r.Fragment, null, r.createElement(f, {
        store: n
      }), t.subSlot.children)), t;
    },
    SwitchSelectionMode: o,
    SwitchSelectionModeButton: function SwitchSelectionModeButton(e) {
      return r.createElement(o, {
        mode: e.mode
      }, function (e) {
        return r.createElement(a, {
          isSelected: e.isSelected,
          mode: e.mode,
          onClick: function onClick() {
            e.onClick();
          }
        });
      });
    },
    SwitchSelectionModeMenuItem: function SwitchSelectionModeMenuItem(e) {
      return r.createElement(o, {
        mode: e.mode
      }, function (t) {
        return r.createElement(m, {
          isSelected: t.isSelected,
          mode: t.mode,
          onClick: function onClick() {
            t.onClick(), e.onClick();
          }
        });
      });
    }
  };
};